import React from 'react';
import { Check, ShieldCheck, Lock, Zap, CreditCard } from 'lucide-react';
const CHECKOUT_URL = 'https://profelisto.com.ar/checkouts/cn/hWNDjK8xok6XA4FtGzeleMFO/es-ar?_r=AQAB5Dds5FvUb5YNI15ozm7me_S8_sCtXQACziicG-3SWbA';
const included = ['Complete Box Set (14 volumes)', '6 Strategic Bonuses', '365-Day Coaching Curriculum', 'Lifetime access', 'Instant digital access'];
export function Pricing() {
  const goToCheckout = () => {
    // Track InitiateCheckout if the Meta Pixel is available, then redirect
    try {
      ;
      (window as any).fbq?.('track', 'InitiateCheckout');
    } catch {
      /* ignore */
    }
    window.location.href = CHECKOUT_URL;
  };
  return <section id="offer-details" className="bg-[#F4F6F2] px-4 py-14 md:py-24" data-id="element-155" data-mp="20t4sdt29qzvl">
      <div className="max-w-3xl mx-auto" data-id="element-156" data-mp="20v7mao6jld5l">
        <div className="text-center mb-9 md:mb-12" data-id="element-157" data-mp="3h6lgm5224xd9">
          <span className="inline-block bg-ink text-acid text-[0.65rem] md:text-[11px] font-bold uppercase tracking-[0.16em] px-4 py-2 md:px-5 md:py-2.5 mb-5 md:mb-7" data-id="element-158" data-mp="3h9hclnuchbz2">
            Limited-time offer
          </span>
          <h2 className="font-display uppercase text-gray-900 text-[7.4vw] min-[430px]:text-3xl md:text-5xl leading-[1.05] mb-3" data-id="element-159" data-mp="4t5kla20v3wz">
            Everything included,{' '}
            <span className="text-neon-deep" data-id="element-160" data-mp="9t0bhdlsrti1">one single price.</span>
          </h2>
          <p className="text-gray-500 text-sm md:text-lg" data-id="element-161" data-mp="eq0gdl6wuq7k">
            No upsells. No surprises.
          </p>
        </div>

        <div className="bg-white shadow-xl border-t-4 border-neon" data-id="element-162" data-mp="3d6uqko3y8i4s">
          <header className="bg-ink text-center px-5 py-7 md:px-6 md:py-9" data-id="element-163" data-mp="3i8tvi2fc7n3u">
            <h3 className="font-display uppercase text-white text-xl md:text-3xl leading-tight mb-2" data-id="element-164" data-mp="3n6vbgehgv6b3">
              Rugby 360 — Complete Box Set
            </h3>
            <p className="text-acid text-xs md:text-base font-medium" data-id="element-165" data-mp="3rzoixa4bksqv">
              1 Main Box Set (14 volumes) + 6 Strategic Bonuses
            </p>
          </header>

          <div className="p-5 md:p-10" data-id="element-166" data-mp="2zfzphxzoz5br">
            <p className="text-center text-[0.7rem] md:text-xs font-bold uppercase tracking-[0.16em] text-gray-500 mb-5 md:mb-7" data-id="element-167" data-mp="2rguxx8i4nmb3">
              What's included
            </p>

            <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-3 md:gap-y-4 mb-8 md:mb-10" data-id="element-168" data-mp="2mfp5zcwak32m">
              {included.map(item => <li key={item} className="flex items-center gap-2.5 md:gap-3" data-id="element-169" data-mp="2w71mj8cn36tc">
                  <span className="w-5 h-5 md:w-6 md:h-6 rounded-full bg-neon/20 text-neon-deep flex items-center justify-center flex-shrink-0" data-id="element-170" data-mp="28i0l45284vxk">
                    <Check size={13} strokeWidth={3} aria-hidden="true" data-id="element-171" data-mp="23jz03el8mmjg" />
                  </span>
                  <span className="font-bold text-gray-900 text-[0.85rem] md:text-[0.95rem]" data-id="element-172" data-mp="2ih7vcjdnwagg">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="border-t border-gray-200 pt-7 md:pt-9 text-center" data-id="element-173" data-mp="3tuaglrqpho6y">
              <p className="text-gray-500 text-sm md:text-base mb-2" data-id="element-174" data-mp="3ows6hy0yd2xd">
                Regular price: <span className="line-through" data-id="element-175" data-mp="anaye07g0op">$97 USD</span>
              </p>

              <div className="flex items-start justify-center gap-1 mb-5" data-id="element-176" data-mp="cqb3qv2na75">
                <span className="font-display text-gray-900 text-3xl md:text-5xl mt-2 md:mt-3" data-id="element-177" data-mp="5artsaol57i3">
                  $
                </span>
                <span className="font-display text-gray-900 text-[4.5rem] md:text-[7rem] leading-[0.85]" data-id="element-178" data-mp="3rgez57uf938v">
                  27
                </span>
                <span className="text-gray-500 text-base md:text-xl font-medium self-end mb-2 md:mb-3 ml-1" data-id="element-179" data-mp="j1erq0miutd4">
                  USD
                </span>
              </div>

              <div className="flex flex-wrap items-center justify-center gap-2.5 md:gap-4 mb-7 md:mb-9" data-id="element-180" data-mp="a9cs24ka1h3w">
                <span className="bg-neon text-ink text-[0.65rem] md:text-xs font-bold uppercase tracking-[0.1em] px-3 py-1.5 md:px-4 md:py-2" data-id="element-181" data-mp="e93jmahmo19h">
                  Save $70
                </span>
                <span className="text-gray-600 text-[0.65rem] md:text-xs font-bold uppercase tracking-[0.1em]" data-id="element-182" data-mp="16rhimdep9ta5">
                  One-time payment
                </span>
                <span className="text-gray-600 text-[0.65rem] md:text-xs font-bold uppercase tracking-[0.1em]" data-id="element-183" data-mp="3a8p549ukjvl8">
                  Lifetime access
                </span>
              </div>

              <button onClick={goToCheckout} className="w-full bg-neon hover:bg-neon-light text-ink font-display uppercase text-lg md:text-2xl tracking-wide py-5 md:py-6 rounded-xl shadow-[0_5px_0_0_var(--neon-deep)] active:translate-y-[3px] active:shadow-[0_2px_0_0_var(--neon-deep)] transition-all" data-id="element-184" data-mp="317qzjn4hfg0j">
                Get Rugby 360 Now
              </button>

              <p className="flex items-center justify-center gap-2 text-gray-500 text-xs md:text-sm mt-4 md:mt-5" data-id="element-185" data-mp="3k6li7772h0lz">
                <ShieldCheck className="text-neon-deep" size={15} data-id="element-186" data-mp="kjn8hqhupswt" />
                Backed by our 7-day money-back guarantee
              </p>
            </div>

            <div className="border-t border-gray-200 mt-7 md:mt-9 pt-5 md:pt-7 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs md:text-sm text-gray-600" data-id="element-187" data-mp="fqajhf99fk3j">
              <span className="flex items-center gap-1.5" data-id="element-188" data-mp="23f9k4absxstg">
                <Lock size={14} data-id="element-189" data-mp="27g35avxv0tin" /> Secure payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-190" data-mp="27hxrseos4tou">
                <Zap size={14} data-id="element-191" data-mp="2cfz9owagymyq" /> Instant access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-192" data-mp="2he961a7xjtlx">
                <CreditCard size={14} data-id="element-193" data-mp="2hdr0fmzdo31c" /> Card · GooglePay · ApplePay
              </span>
            </div>
          </div>
        </div>

        <p className="text-center text-gray-500 text-xs md:text-sm mt-5 md:mt-7" data-id="element-194" data-mp="2r3sncbfzvfeo">
          You'll be charged in your local currency.
        </p>
      </div>
    </section>;
}